export default __webpack_public_path__ + "static/media/justicecoin.0aa2936c.jpeg";